import { Header } from '../nav/Header';
import AutomationRulesComponent from '../settings/AutomationRules';
import { useProfileSelection } from '../../context/ProfileSelectionContext';
import { useAccount } from '../../context/AccountContext';

export function AutomationRulesLayout() {
  const { selectedAccount, setSelectedAccount, selectedProfiles, setSelectedProfiles } =
    useProfileSelection();
  const { refetchAccounts } = useAccount();

  const handleRefetch = () => {
    if (selectedAccount) {
      refetchAccounts();
    }
  };

  return (
    <div className="ink-page flex w-full flex-col h-full min-h-0 overflow-hidden">
      <div className="flex flex-col flex-1 overflow-y-auto md:overflow-hidden">
        <Header
          showPlatformToggle={true}
          selectedProfiles={selectedProfiles}
          onProfileToggle={setSelectedProfiles}
          selectedAccount={selectedAccount}
          onAccountChange={setSelectedAccount}
        />
        <div className="w-full max-w-full overflow-hidden relative flex-1 flex flex-col">
          <div className="p-1 m-0 w-full h-full relative overflow-hidden box-border bg-primary-background flex flex-col">
            <div className="p-6 h-full overflow-auto bg-core-dark">
              {selectedAccount ? (
                <AutomationRulesComponent
                  accountId={selectedAccount.id}
                  onRefetch={handleRefetch}
                  selectedProfiles={selectedProfiles}
                />
              ) : (
                <div className="text-white">Loading account...</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
